// BuildingsComponent.jsx
import { useEffect, useState } from "react";
import {
  CounterField,
  Operation,
} from "components/counterField/counterField.tsx";
import Building from "../components/building";
import { EditableInputComponent } from 'components/index';
import { BuildingDTO } from 'shared/types/building';
import { v4 as uuidv4 } from 'uuid';


const AcquisitionBuildings = ({ updateAcquisitionFile, buildings, acquisitionFile }: any) => {
  const [localBuildings, setLocalBuildings] = useState(buildings);
  const [title, setTitle] = useState(acquisitionFile && acquisitionFile.name || "");
  const [titleError, setTitleError] = useState("");

  useEffect(() => {
    if (!acquisitionFile) return;
    // Only auto-set title if it's not an email import and we have one building
    if (!acquisitionFile.isEmailImport && localBuildings.length === 1) {
      setTitle(localBuildings[0].location.description);
      updateAcquisitionFile({ name: localBuildings[0].location.description });
      validateTitle(localBuildings[0].location.description);
    } else if (!acquisitionFile.isEmailImport) {
      if (!title || title == "") {
        setTitle(acquisitionFile.name || "");
        updateAcquisitionFile({ name: acquisitionFile.name || "" });
        validateTitle(acquisitionFile.name || "");
      }
    }
  }, [localBuildings, updateAcquisitionFile, acquisitionFile.isEmailImport]);

  const validateTitle = (value: string) => {
    if (value && value.length > 40) {
      setTitleError("Naam mag niet langer zijn dan 40 tekens");
      return false;
    }
    setTitleError("");
    return true;
  };

  const handleBuildingChange = (operation: any) => {
    if (operation === Operation.increment) {
      if (localBuildings && localBuildings.length == 1) {
        setTitle("");
        updateAcquisitionFile({ name: "" });
      }
      const newBuilding: BuildingDTO = {
        id: "",
        tempId: uuidv4(),
        location: "",
        buildingAlreadyRenovated: [],
        buildingToRenovate: [],
        owner: false,
        buildingAcquisitionInfo: {
          acquisitionFileNumResidentialUnits: 0,
          acquisitionFileNumRetailUnits: 0,
          acquisitionFileNumOfficeUnits: 0,
          acquisitionFileNumParkingsInside: 0,
          acquisitionFileNumParkingsOutside: 0,
          acquisitionFileNumBicycleSheds: 0,
          acquisitionFileNumStorages: 0,
          acquisitionFileBuildingDescription: "",
        },
      };
      updateAcquisitionFile({ buildings: [...localBuildings, newBuilding] });
      setLocalBuildings([...localBuildings, newBuilding]);
    } else if (operation === Operation.decrement && localBuildings.length > 1) {
      updateAcquisitionFile({ buildings: [...localBuildings.slice(0, -1)] });
      setLocalBuildings(localBuildings.slice(0, -1));
    }
  };

  const handleUpdateBuildingDetails = (
    buildingTempId: any,
    field: any,
    value: any,
  ) => {
    const updatedBuildings = localBuildings.map((building: any) => {
      if (building.tempId === buildingTempId) {
        if (field.startsWith("acquisitionFile")) {
          return {
            ...building,
            buildingAcquisitionInfo: {
              ...building.buildingAcquisitionInfo,
              [field]: value,
            },
          };
        }
        return { ...building, [field]: value };
      }
      return building;
    });
    setLocalBuildings(updatedBuildings);
    updateAcquisitionFile({ buildings: updatedBuildings });
  };

  const handleTitleChange = (value: any) => {
    setTitle(value);
    updateAcquisitionFile({ name: value });
    validateTitle(value);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full flex-col gap-2">
        <label htmlFor="titleField" className="text-sm">
          Naam van de transactie (automatisch ingevuld indien slechts één
          gebouw)
        </label>
        {titleError && (
          <div className="text-red-500 text-sm mb-1">{titleError}</div>
        )}
        <EditableInputComponent
          editMode={true}
          isLoading={false}
          label="Adres / Vennootschap / Portefeuillenaam"
          value={title}
          onChange={handleTitleChange}
        />
      </div>
      <div className="flex w-full items-center">
        <CounterField
          min={1}
          defaultCount={localBuildings.length}
          handleCountChange={handleBuildingChange}
          label="Gebouwen*"
        />
      </div>
      {localBuildings.map((building: any, index: number) => (
        <Building
          key={building.tempId || index}  // Use building ID if available, else fall back to index
          building={building}
          updateBuildingDetails={handleUpdateBuildingDetails}
        />
      ))}

    </div>
  );
};

export default AcquisitionBuildings;
